import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export class EventYearCalendarService {
    constructor() {
        this.invokeFirstComponentFunction = new EventEmitter();
    }
    onYearChange(year) {
        this.invokeFirstComponentFunction.emit(year);
    }
}
EventYearCalendarService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventYearCalendarService_Factory() { return new EventYearCalendarService(); }, token: EventYearCalendarService, providedIn: "root" });
